<!-- 聊天 -->
<template>
  <el-row class="message">
    <div class="content">
      <div class="top">{{userName}}</div>
      <div class="center">
        <div class="msg" ref="box">
          <div v-for="item in list" :class="{'msg-item':(item.senderIsUser == 0),'msg-itemL':(item.senderIsUser == 1)}">
            <div style="text-align: center; font-size: 10px; color: #b4b4b4">{{ item.messageDatetime }}</div>
            <!-- 用户 -->
            <div style="display: flex; flex-direction: row; margin: 3px 0; max-width:380px" v-if="item.senderIsUser == 1">
              <div style="width:40px; height:46px; padding: 0 3px;"><el-image style="width:40px; height:40px;" :src="memberPortrait"/></div>
              <div v-if="item.content == '' && item.houseId != 0">
                <div style="width: 300px; background:#ffffff;padding:15px; border-radius:5px">
                  <div style="width:100%; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">{{ item.housedetails.title }}</div>
                  <div style="width:100%; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis; color:#676867; padding: 10px 0;">房源编号:{{ item.housedetails.no }}</div>
                  <div style="width:100%; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis; color:#676867;">${{ item.housedetails.price }} 起/周</div>
                  <div style="padding: 10px 0;"><el-image style="width:100%" :src=' item.housedetails.photoList[0]'/></div>
                  <div style="width:100%; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis; color:#676867;">{{ item.housedetails.city }}</div>
                </div>
              </div>
              <div v-else>
                <el-image :preview-src-list="item.srcList" style="max-width: 120px" v-if="item.content.toLowerCase().indexOf('.jpg') > -1 || item.content.toLowerCase().indexOf('.png') > -1 || item.content.toLowerCase().indexOf('.jpeg') > -1 || item.content.toLowerCase().indexOf('.gif') > -1" :src="item.content" />
                <p v-else>{{ item.content }}</p>
              </div>
            </div>
            <!-- 客服 -->
            <div style="display: flex; flex-direction: row; float: right; margin: 3px 0; max-width:380px" v-if="item.senderIsUser == 0">
              <el-image :preview-src-list="item.srcList" style="max-width: 120px" v-if="item.content.toLowerCase().indexOf('.jpg') > -1 || item.content.toLowerCase().indexOf('.png') > -1 || item.content.toLowerCase().indexOf('.jpeg') > -1 || item.content.toLowerCase().indexOf('.gif') > -1" :src="item.content" />
              <p v-else>{{ item.content }}</p>
              <div style="width:40px; height:46px; padding: 0 3px;"><el-image style="width: 40px; height: 40px" src="../../../static/images/user.png"/></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <el-input v-model="contentText" placeholder="请输入内容"></el-input>
        <el-button type="primary"  :style="{padding:'5px 20px !important',margin:'5px 10px'}"size="mini" @click="websocketonopen">发送</el-button>
        <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :http-request="handleHttpRequestPhoto" :show-file-list="false">
          <i class="el-icon-picture" :style="{fontSize: '30px',cursor:'pointer', color:'#409EFF',marginTop:'6px' }"></i>
        </el-upload>
      </div>
    </div>
  </el-row>
</template>

<script>
  export default {
    name: "Message",
    data() {
      return {
        list: [],//聊天记录的数组
        contentText: "",//input输入的值
        user:"",// 用户
        userName:"",// 用户名称
        memberPortrait:"",// 用户头像
        randomNumber:'', // 随机数
      }
    },
    methods: {
      //初始化weosocket
      initWebSocket(){
        let char = "1234567890";
        for(let j = 1; j <= 4; j++){
          let i = parseInt(10*Math.random());
          this.randomNumber = this.randomNumber + char.charAt(i);
        }
        this.$global.ws = new WebSocket(wss_url+"/IM/customerService"+ this.randomNumber);
        this.$global.setWs(this.$global.ws);
        this.$global.ws.onmessage = this.websocketonmessage;
        this.$global.ws.onerror = this.websocketonerror;
        this.$global.ws.onclose = this.websocketonerror;
      },
      //收到消息
      websocketonmessage(e) {
        console.log(e);
        this.getMessage(this.$route.query.memberId);
      },
      //连接建立失败重连
      websocketonerror(){
        this.$global.ws = new WebSocket(wss_url+"/IM/customerService"+ this.randomNumber);
        this.$global.setWs(this.$global.ws);
        this.$global.ws.onmessage = this.websocketonmessage;
        this.$global.ws.onerror = this.websocketonerror;
        this.$global.ws.onclose = this.websocketonerror;
      },
      //连接建立之后执行send方法发送数据
      websocketonopen(){
        let actions = {"memberId":this.$route.query.memberId,"content":this.contentText};
        this.$global.ws.send(JSON.stringify(actions));
        this.contentText = "";
        this.getMessage(this.$route.query.memberId);
      },
      // 获取图片信息
      async handleHttpRequestPhoto(data) {
        this.contentText = await this.uploadFile(data.file);
        this.websocketonopen();
      },
      // 上传图片
      async uploadFile(data){
        let photo = '';
        let formData = new FormData();
        formData.append('file',data)
        await this.$api.fileUpload(formData).then(res => {
          if (res.data.status == 200) {
            photo = res.data.data[0].path;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
        return photo;
      },
      // 获取消息
      getMessage(memberId){
        let parameter = [ {
          "criteria": "or",
          "data": [
            {
              "field": "memberId",
              "fun": "eq",
              "value": memberId
            },
            {
              "field": "adviserId",
              "fun": "eq",
              "value": memberId
            }
          ]
        }];
        this.$api.findMessage({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(async res => {
          if (res.data.status == 200) {
            for(let i = 0; i < res.data.data.records.length; i++){
              if(res.data.data.records[i].houseId != 0 && res.data.data.records[i].houseId != null && res.data.data.records[i].houseId != ''){
                res.data.data.records[i].housedetails = await this.getGoods(res.data.data.records[i].houseId);
                let photo = res.data.data.records[i].housedetails.photo.split('|');
                res.data.data.records[i].housedetails.photoList = [];
                if(photo != ''){
                  for(let j = 0; j < photo.length; j++){
                    res.data.data.records[i].housedetails.photoList.push(api_url+"/"+photo[j]);
                  }
                }
              }
            }
            this.list = res.data.data.records;
            for (let i = 0 ; i < this.list.length; i++){
              if (this.list[i].content.toLowerCase().indexOf('.jpg') >-1 || this.list[i].content.toLowerCase().indexOf('.jpeg') >-1 || this.list[i].content.toLowerCase().indexOf('.png') >-1|| this.list[i].content.toLowerCase().indexOf('.gif') >-1){
                this.list[i].content =  api_url+"/"+this.list[i].content;
                this.list[i].srcList = [];
                this.list[i].srcList.push(this.list[i].content);
              }
            }
            let that = this;
            that.$nextTick(() => {
              let div = that.$refs.box;
              div.scrollTop = div.scrollHeight;
            });
            setTimeout(function(){
              if(that.list != ''){
                let actions = {"read":true,"memberId":that.$route.query.memberId};
                console.log(actions);
                that.$global.ws.send(JSON.stringify(actions));// 更改消息变为已读
              }
            },1000)
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 获取房源信息
      async getGoods(id){
        let data = {};
        await this.$api.findHouseById({
          id:id,
        }).then(res => {
          if (res.data.status == 200) {
            data = res.data.data;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
        return data;
      },
    },
    mounted() {
      this.initWebSocket();
      if (this.$route.query.memberId != undefined){
        this.$store.dispatch('setMemberIdValue',this.$route.query.memberId);
        this.user = this.$route.query.memberId;
        this.userName = this.$route.query.memberName;
        this.memberPortrait = this.$route.query.memberPortrait;
        this.getMessage(this.$route.query.memberId);
      }
    },
  };

</script>

<style scoped>
  .message{
    width: 100%;
    background: #555555;
    height: 100vh;
  }

  .message .content{
    width: 700px;
    height:548px;
    background-color: #f2f2f2;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    border-radius: 5px;
  }

  .message .content .top{
    height: 45px;
    line-height: 45px;
    background-color: #d7d7d7;
    padding-left: 10px;
  }

  .message .content .center{
    background: #f2f2f2;
    height: 450px;
    border-bottom: 1px solid #ababab;
    border-top: 1px solid #ababab;

  }

  .message .content .bottom{
    background-color: #ffffff;
    padding:5px 10px;
    display: flex;
    flex-direction: row;
  }

  .msg {
    width: 100%;
    height: calc(100% - 10px);;
    overflow: auto;
    padding-top: 5px;
    display: inline-block;
    margin-bottom: 6px;
  }

  .msg .msg-item,.msg .msg-itemL {
    position: relative;
    overflow: hidden;
  }

  .msg .msg-item p {
    min-height: 40px;
    display: inline-block;
    background: #ffffff;
    color: black;
    padding: 0 12px;
    line-height: 30px;
    margin: 0;
    text-align: left;
    border-radius: 5px;
  }

  .msg .msg-itemL p {
    min-height: 40px;
    display: inline-block;
    background: #ffffff;
    color: black;
    padding: 0 12px;
    line-height: 30px;
    margin: 0;
    text-align: left;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu/Message.vue